const logos = {
  bol: '/assets/images/bol-logo.jpg',
  exact: '/assets/images/exact-logo.png',
  shopctrl: '/assets/images/shopctrl-logo.jpeg',
  mollie: '/assets/images/mollie-logo.png',
  cmpayments: '/assets/images/cm-logo.png',
  paynl: '/assets/images/paynl-logo.png',
  sendcloud: '/assets/images/sendcloud-logo.jpg',
  dpd: '/assets/images/dpd-logo.png',
  recaptcha: '/assets/images/recaptcha-logo.png',
  slack: '/assets/images/slack-logo.png',
  qls: '/assets/images/qls-logo.png',
  default: '/assets/images/afosto-logov2.png',
};

export default logos;
